import React from 'react';
import { StyleSheet } from 'react-native';

// Web shim for react-native-video using HTML <video>
const Video = React.forwardRef(function Video(
  { source, style, onLoad, onError, onEnd, paused, muted, volume, resizeMode, controls = true, ...props },
  ref
) {
  const uri = source?.uri || (typeof source === 'string' ? source : '');

  return (
    <video
      ref={ref}
      src={uri}
      autoPlay={!paused}
      muted={muted}
      controls={controls}
      onLoadedData={onLoad}
      onError={onError}
      onEnded={onEnd}
      style={StyleSheet.flatten([{ width: '100%', height: '100%' }, style])}
      {...props}
    />
  );
});

export default Video;
